(() => {
  const BAR_SELECTOR = '[data-free-shipping-bar]';

  function barsOnPage() {
    return Array.from(document.querySelectorAll(BAR_SELECTOR));
  }

  async function fetchCart() {
    const res = await fetch('/cart.js', { credentials: 'same-origin' });
    if (!res.ok) throw new Error('Failed to load cart.js');
    return res.json();
  }

  function updateBarsFromCart(cart) {
    const bars = barsOnPage();
    if (!bars.length) return;

    const total = (cart.total_price || 0) / 100;

    bars.forEach((bar) => {
      const threshold = parseFloat(bar.getAttribute('data-threshold') || '30');
      const fill = bar.querySelector('.pp-free-ship__fill');
      const text = bar.querySelector('.pp-free-ship__text');

      if (!threshold || !fill || !text) return;

      const pct = Math.max(0, Math.min(100, (total / threshold) * 100));
      fill.style.width = pct + '%';

      const remaining = threshold - total;

      if (remaining <= 0) {
        text.textContent = 'You unlocked FREE Shipping! 🎉';
      } else {
        text.textContent = `Add $${remaining.toFixed(2)} to unlock FREE Shipping!`;
      }
    });
  }

  let t;
  async function runUpdate() {
    if (!barsOnPage().length) return;
    try {
      const cart = await fetchCart();
      updateBarsFromCart(cart);
    } catch (e) {
      // keep silent to avoid console spam
    }
  }

  function schedule(ms = 200) {
    clearTimeout(t);
    t = setTimeout(runUpdate, ms);
  }

  // Run on load + after page restore (Safari)
  document.addEventListener('DOMContentLoaded', () => {
    schedule(50);
    schedule(600);
  });
  window.addEventListener('pageshow', () => schedule(80));

  // Catch dynamic HTML replacements (cart drawer re-render)
  const mo = new MutationObserver(() => schedule(150));
  mo.observe(document.documentElement, { childList: true, subtree: true });

  // Catch fetch-based cart updates
  const _fetch = window.fetch;
  window.fetch = async (...args) => {
    const res = await _fetch(...args);
    try {
      const url = typeof args[0] === 'string' ? args[0] : (args[0]?.url || '');
      if (/\/cart(\.js|\/(add|change|update|clear)\.js)/.test(url)) {
        schedule(250);
        schedule(900);
      }
    } catch (_) {}
    return res;
  };

  // Catch XHR-based cart updates (some themes use this)
  const _open = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url, ...rest) {
    this._ppfs_url = url;
    return _open.call(this, method, url, ...rest);
  };
  const _send = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function (...args) {
    this.addEventListener('load', () => {
      try {
        if (this._ppfs_url && /\/cart(\.js|\/(add|change|update|clear)\.js)/.test(this._ppfs_url)) {
          schedule(250);
          schedule(900);
        }
      } catch (_) {}
    });
    return _send.apply(this, args);
  };

  // Update when user opens the cart drawer / cart page
  document.addEventListener('click', (e) => {
    const el = e.target.closest(
      '[data-testid="cart-drawer-trigger"], a[href="/cart"], button[name="checkout"], .header__icon--cart, [href*="/cart"]'
    );
    if (el) {
      schedule(250);
      schedule(900);
    }
  });

  // Expose a manual hook (optional)
  window.PlaypatchFreeShipping = { update: runUpdate };
})();
